import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Layout from '../Layout';
import Seo from '../component/Seo';
import { langPathSuffix } from '../lang-utils';
import Faq from '../component/FaqSection';

const SEO = {
  lt: {
    title: 'Dažniausiai užduodami klausimai (DUK) | Geltonas Traliukas',
    description: 'Atsakymai į dažniausius klausimus apie tralo paslaugas: kur teikiame paslaugą, kokias transporto priemones transportuojame, per kiek laiko atvykstame.',
    h1: 'Dažniausiai užduodami klausimai',
    intro: 'Žemiau rasite atsakymus į dažniausiai klientų užduodamus klausimus apie mūsų tralo ir pagalbos kelyje paslaugas. Jei nerandate atsakymo, prašome susisiekti su mumis tiesiogiai.',
    crossTitle: 'Daugiau informacijos',
    crossService: 'Mūsų paslaugos',
    crossGallery: 'Darbų galerija',
    crossContact: 'Susisiekti'
  },
  en: {
    title: 'Frequently asked questions (FAQ) | Geltonas Traliukas',
    description: 'Answers to the most common questions about our tow truck services: where we operate, what vehicles we transport, how fast we arrive.',
    h1: 'Frequently asked questions',
    intro: 'Below you will find answers to the questions our customers ask most often about our tow truck and roadside assistance services. If your question is not covered, please contact us directly.',
    crossTitle: 'More information',
    crossService: 'Our services',
    crossGallery: 'Work gallery',
    crossContact: 'Contact us'
  },
  ru: {
    title: 'Часто задаваемые вопросы (FAQ) | Geltonas Traliukas',
    description: 'Ответы на самые частые вопросы о услугах эвакуатора: где работаем, какие машины перевозим, как быстро приезжаем.',
    h1: 'Часто задаваемые вопросы',
    intro: 'Ниже вы найдёте ответы на наиболее частые вопросы клиентов об услугах эвакуатора и помощи на дороге. Если не нашли свой вопрос — пожалуйста, свяжитесь с нами напрямую.',
    crossTitle: 'Больше информации',
    crossService: 'Наши услуги',
    crossGallery: 'Галерея работ',
    crossContact: 'Связаться'
  }
};

function DukPage({ lang = 'lt' }) {
  const t = SEO[lang] || SEO.lt;
  return (
    <Layout
      lang={lang}
      renderChildren={({ strings, pageWidth, onTop }) => {
        return (
          <>
            <Seo path="/duk/" lang={lang} title={t.title} description={t.description} pageName={strings.navbar.faq} />
            <Container className="section-padding">
              <div className="text-center">
                <h1 className="section-title">{t.h1}</h1>
                <div className="section-underline" />
              </div>
              <p className="text-justify page-intro">{t.intro}</p>
            </Container>
            <Faq strings={strings} onTop={onTop} pageWidth={pageWidth} section="dark" hideTitle />
            <Container className="section-padding">
              <h2 className="text-center">{t.crossTitle}</h2>
              <ul className="cross-links">
                <li><Link to={`/paslaugos/${langPathSuffix(lang)}`}>{t.crossService}</Link></li>
                <li><Link to={`/galerija/${langPathSuffix(lang)}`}>{t.crossGallery}</Link></li>
                <li><Link to={`/kontaktai/${langPathSuffix(lang)}`}>{t.crossContact}</Link></li>
              </ul>
            </Container>
          </>
        );
      }}
    />
  );
}

export default DukPage;
